export const TITLE: string = "KoçAilem Alışveriş";
export const LOCAL_STORAGE = {
  ACCESS_TOKEN: "ACCESS_TOKEN",
  USER_ID: "USER_ID",
  USER_FULLNAME: "USER_FULLNAME",
  PERMISSIONS: "PERMISSIONS",
  USER_EMAIL: "USER_EMAIL",
  EXPIRED_TIME: "EXPIRED_TIME",
  REFRESH_TOKEN: "REFRESH_TOKEN",
  POSITION: "POSITION",
  AUTO_LOGOUT_EXPIRED: "AUTO_LOGOUT_EXPIRED",
  LAST_ACTIVITY_TIME: "LAST_ACTIVITY_TIME",
};
export const MESSAGE_TYPE = {
  SUCCESS: "success",
  ERROR: "error",
  INFO: "info",
  WARNING: "warning",
};
export const DEFAULT_PAGE_SIZE: number = 10;
export const PAGE_SIZE_OPTIONS: Array<number> = [10, 20, 30];
export const SELECT_EMPTY: string = "EMPTY";
